import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';
import { css } from '@emotion/core';
import PageSection from '../components/PageSection';
import UnderscoreDivider from '../components/UnderscoreDivider';
import { Header2, Paragraph } from '../components/Typography';
import HorizontalBarChart from '../components/HorizontalBarChart';
import phrasesType from '../proptypes/phrases';
import rankingType from '../proptypes/ranking';
import selectAttributesBarChartData from '../selectors/attributes-bar-chart-data';
import {
  ssColorWhite,
} from '../constants/style-constants';

const headingRowCss = css`
  color: ${ssColorWhite};
  margin-bottom: 2rem;

  ${Header2} {
    color: ${ssColorWhite};
  }

  ${UnderscoreDivider} {
    margin: 2rem 0;
  }
`;

const AttributesChartSection = ({ attributePath, ranking, phrases }) => {
  const formatValue = (ceil, value) => {
    if (value === 0) {
      return phrases.noData;
    }
    return `${value}/${ceil}`;
  };

  const attributeBarChartRowData = selectAttributesBarChartData(ranking, phrases, attributePath);

  return (
    <PageSection>
      <div className="row">
        <div className="col" css={headingRowCss}>
          <Header2>Understand your attributes</Header2>
          <UnderscoreDivider />
          <Paragraph>Tap an attribute below to explore their meaning.</Paragraph>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <HorizontalBarChart
            formatValue={formatValue}
            ceilingValue={10}
            rows={attributeBarChartRowData}
          />
        </div>
      </div>
    </PageSection>
  );
};

AttributesChartSection.defaultProps = {
  attributePath: null,
};

AttributesChartSection.propTypes = {
  attributePath: PropTypes.string,
  ranking: rankingType.isRequired,
  phrases: phrasesType.isRequired,
};

export default hot(AttributesChartSection);
